import { render } from "./TopBarMenu.vue?vue&type=template&id=478320c8&scoped=true"
import script from "./TopBarMenu.vue?vue&type=script&lang=js"
export * from "./TopBarMenu.vue?vue&type=script&lang=js"

import "./TopBarMenu.vue?vue&type=style&index=0&id=478320c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478320c8"]])

export default __exports__